import { InjectionToken } from '@angular/core';
import {
  FeatureFlags,
  createDefaultFeatures,
} from '../models/feature-flags.model';

/**
 * Injection token for the default FeatureFlags model instance.
 * Used by FeatureFlagsService for fallback when LaunchDarkly is unavailable.
 *
 * This provides the hardcoded default values that are used when:
 * - LaunchDarkly is disabled in configuration
 * - LaunchDarkly initialization fails
 * - LaunchDarkly times out
 */
export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('FeatureFlags', {
  providedIn: 'root',
  factory: () => {
    return createDefaultFeatures();
  },
});
